import { z } from 'zod';

// ─── Platform Ticket Category (B2B SaaS Issues) ──────────────────────────────
export const PlatformTicketCategorySchema = z.enum([
  'system_bug',          // ระบบขัดข้อง / พบข้อผิดพลาด
  'integration_pms',     // ปัญหาการเชื่อมต่อ PMS / POS / Channel Manager
  'payment_gateway',     // ปัญหาเกตเวย์ชำระเงิน (Stripe, PromptPay, ฯลฯ)
  'feature_request',     // ขอฟีเจอร์หรือโมดูลใหม่
  'billing',             // สอบถามบิลค่าบริการ / แพ็กเกจการใช้งาน
  'general',             // สอบถามการใช้งานทั่วไป
]);
export type PlatformTicketCategory = z.infer<typeof PlatformTicketCategorySchema>;

// ─── Platform Ticket Status ──────────────────────────────────────────────────
export const PlatformTicketStatusSchema = z.enum([
  'open',           // รอทีมงานตรวจสอบ
  'investigating',  // ทีมงานกำลังตรวจสอบและแก้ไข
  'resolved',       // แก้ไขเรียบร้อยแล้ว
  'closed',         // ปิดงาน
]);
export type PlatformTicketStatus = z.infer<typeof PlatformTicketStatusSchema>;

// ─── Platform Ticket Priority ────────────────────────────────────────────────
export const PlatformTicketPrioritySchema = z.enum(['low', 'medium', 'high', 'urgent']);
export type PlatformTicketPriority = z.infer<typeof PlatformTicketPrioritySchema>;

// ─── Reporter Details ────────────────────────────────────────────────────────
export const PlatformTicketReporterSchema = z.object({
  uid: z.string(),
  name: z.string(),
  email: z.string(),
  role: z.string().default('admin'),
  phone: z.string().optional(),
});
export type PlatformTicketReporter = z.infer<typeof PlatformTicketReporterSchema>;

// ─── Platform Ticket Schema ──────────────────────────────────────────────────
export const PlatformTicketSchema = z.object({
  id: z.string(),
  ticketNumber: z.string(),
  tenantId: z.string(),
  tenantName: z.string().default(''),
  reporter: PlatformTicketReporterSchema,
  category: PlatformTicketCategorySchema.default('general'),
  priority: PlatformTicketPrioritySchema.default('medium'),
  subject: z.string(),
  description: z.string(),
  attachments: z.array(z.string()).default([]),
  status: PlatformTicketStatusSchema.default('open'),
  adminResponse: z.string().optional(),
  adminRespondedAt: z.string().optional(),
  adminResponderName: z.string().optional(),
  resolvedAt: z.string().optional(),
  closedAt: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type PlatformTicket = z.infer<typeof PlatformTicketSchema>;

// ─── Input Schemas ───────────────────────────────────────────────────────────
export const CreatePlatformTicketInputSchema = z.object({
  category: PlatformTicketCategorySchema.default('general'),
  priority: PlatformTicketPrioritySchema.default('medium'),
  subject: z.string().min(1, 'Subject is required'),
  description: z.string().min(1, 'Description is required'),
  attachments: z.array(z.string()).optional(),
  reporterPhone: z.string().optional(),
});
export type CreatePlatformTicketInput = z.infer<typeof CreatePlatformTicketInputSchema>;

export const UpdatePlatformTicketInputSchema = z.object({
  status: PlatformTicketStatusSchema.optional(),
  priority: PlatformTicketPrioritySchema.optional(),
  category: PlatformTicketCategorySchema.optional(),
  adminResponse: z.string().optional(),
});
export type UpdatePlatformTicketInput = z.infer<typeof UpdatePlatformTicketInputSchema>;
